/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ContentBlock, SearchActions, Stack, useBreakpoint } from 'sarsaparilla';

import HeroContainer from '../../containers/homepage/HeroContainer';
import { NewsletterPromoAndModal } from './newsletter/NewsletterPromoAndModal';
import DiscoverContainer from '../../containers/homepage/DiscoverContainer';
import { ExploreAllQuickPromos } from '../../containers/homepage/ExploreAllQuickPromos/ExploreAllQuickPromos';
import { InspirationAndInformation } from '../../containers/homepage/InspirationAndInformation';

import { RecommendationCarousels } from './recommendationCarousels/RecommendationCarousels';
import { FeaturedPromos } from './featuredPromos/FeaturedPromos';
import { ExploreDestinationsMap } from './ExploreDestinationsMap/ExploreDestinationsMap';

interface HomePageContentProps {
    submitSimpleSearch: (
        ...args: Parameters<typeof SearchActions.submitSimpleSearch>
    ) => void;
}

export function HomePageContent({ submitSimpleSearch }: HomePageContentProps) {
    const { isSmAndDown } = useBreakpoint();

    return (
        <div role="main" className="nav-homepage-wrap">
            <h1 className="rec-sr-only">{process.env.SITE_NAME}</h1>

            <HeroContainer submitSimpleSearch={submitSimpleSearch} />

            <Stack space="xxl">
                {isSmAndDown ? (
                    <div className="promos-container">
                        <ExploreAllQuickPromos search={submitSimpleSearch} />
                    </div>
                ) : null}

                <RecommendationCarousels position="upper" />

                <FeaturedPromos position="upper" />

                <RecommendationCarousels position="lower" />

                <ExploreDestinationsMap />

                <FeaturedPromos position="lower" />

                <InspirationAndInformation />

                <ContentBlock>
                    <NewsletterPromoAndModal />
                </ContentBlock>

                {process.env.FEATURES?.discover ? <DiscoverContainer /> : null}
            </Stack>
        </div>
    );
}
